import { render, staticRenderFns } from "./PatientLatestBloodResults.vue?vue&type=template&id=2b9674a0&scoped=true"
import script from "./PatientLatestBloodResults.vue?vue&type=script&lang=js"
export * from "./PatientLatestBloodResults.vue?vue&type=script&lang=js"
import style0 from "./PatientLatestBloodResults.vue?vue&type=style&index=0&id=2b9674a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9674a0",
  null
  
)

export default component.exports